import { useLocation } from 'react-router-dom'
import React, {useState} from 'react';
import './nftdetail.css';
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import productim from './im/product.jpg';
import authorim from './im/avatar.png'
import {
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane
} from 'mdb-react-ui-kit';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import Footerr from '../Footer/Footerr';



function NFTDetail() {
  const [justifyActive, setJustifyActive] = useState('tab1');
  const location = useLocation()

  const handleJustifyClick = (value) => {
    if (value === justifyActive) {
      return;
    }

    setJustifyActive(value);
  };
  return (
    <div>
      <MDBContainer className='product-page'>
        <MDBRow>
          <MDBCol className='product-col' md="6" sm="1">
            <img className='product-image' src={productim} />
          </MDBCol>
          <MDBCol className='product-col' md="6" sm="1">
            <h1>NFT Title</h1>
            <div className='author-box'>
                <img className='author-image' src={authorim} />
                <h3>Author Name</h3>
                <p>@Author Description</p>
            </div>
            <MDBRow className='product-price-details'>
              <MDBCol md="4" sm="6">
                <h4 className='product-desc-title'>CURRENT BID</h4>
                <h2 className='product-bid-price'>2.31 ETH</h2>
                <span className='price-in-usd'>125.230 U$D</span>
              </MDBCol>
              <MDBCol md="4" sm="6">
                <h4 className='product-desc-title'>EDITION</h4>
                <h2 className='product-bid-price'>01/40</h2>
                <span className='price-in-usd'>Tokens</span>
              </MDBCol>
              <MDBCol md="4" sm="12">
              <h4 className='product-desc-title'>AUCTION ENDING IN</h4>
              </MDBCol>
            </MDBRow>
            <div className='nft-description'>
              <h4 className='product-desc-title'>DESCRIPTION</h4>
              <p className='product-desc-text'>
              I am a self-taught digital artist who specializes in 3d art and motion graphics. 
              Most of my works are inspired by nature and biomechanic themes.
              What does it mean? Biomechanics is the study of the structure, 
              function and motion of the mechanical aspects of biological systems, 
              at any level from whole organisms to organs, cells and cell organelles, 
              using the methods of mechanics. Biomechanics is a branch of biophysics.
              </p>
            </div>
            <MDBRow className='purchase-section'>
              <MDBCol md='4' sm='12'>
                <button className='place-a-bid-btn'>Place a Bid !</button>
              </MDBCol>
              <MDBCol md='2' sm='6'>
                <button className='product-like-btn'><i class="fa fa-heart" aria-hidden="true"></i></button>
              </MDBCol>
              <MDBCol md='2' sm='6'>
                <button className='product-menu-btn'>...</button>
              </MDBCol>
              <MDBCol md='4' sm='12'>
                <div className='social-icons-single'>
                  <i class="fa fa-facebook-square" aria-hidden="true"></i>
                  <i class="fa fa-twitter-square" aria-hidden="true"></i>
                  <i class="fa fa-instagram" aria-hidden="true"></i>
                </div>
              </MDBCol>
            </MDBRow>
            <MDBRow className='product-desc-tabs'>
              <MDBCol>
                <MDBTabs justify className='product-tab-head mb-3'>
                  <MDBTabsItem>
                    <MDBTabsLink onClick={() => handleJustifyClick('tab1')} active={justifyActive === 'tab1'}>
                      Bids
                    </MDBTabsLink>
                  </MDBTabsItem>
                      <MDBTabsItem>
                        <MDBTabsLink onClick={() => handleJustifyClick('tab2')} active={justifyActive === 'tab2'}>
                          Additional Details
                        </MDBTabsLink>
                      </MDBTabsItem>
                          <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleJustifyClick('tab3')} active={justifyActive === 'tab3'}>
                              Activity
                            </MDBTabsLink>
                          </MDBTabsItem>
                 </MDBTabs>
                              <MDBTabsContent>
                                <MDBTabsPane show={justifyActive === 'tab1'}>Tab 1 content</MDBTabsPane>
                                <MDBTabsPane show={justifyActive === 'tab2'}>
                                <MDBTable className="product-desc-table" borderless>
                                  <MDBTableHead>
              
                                  </MDBTableHead>
                                  <MDBTableBody>
                                    <tr>
                                      <td>Size</td>
                                      <td>5000 x 3500px (37MB)</td>
                                    </tr>
                                    <tr>
                                      <td>Formats</td>
                                      <td>MP4, JPEG and PNG</td>
                                    </tr>
                                    <tr>
                                      <td>Contract Address</td>
                                      <td>0xf7a6...f643</td>
                                    </tr>
                                    <tr>
                                      <td>Token ID</td>
                                      <td>3584</td>
                                    </tr>
                                    <tr>
                                      <td>Token Standard</td>
                                      <td>ERC-721</td>
                                    </tr>
                                    <tr>
                                      <td>Blockchain</td>
                                      <td>Ethereum</td>
                                    </tr>
                                  </MDBTableBody>
                                </MDBTable>
                                  </MDBTabsPane>
                                <MDBTabsPane className='activity-tab' show={justifyActive === 'tab3'}>
                                 <div className='activity-card'>
                                   <div>
                                     <img className='activity-image' src={authorim} />
                                   </div>
                                   <div className='activity-author'>
                                     <h4>Author Name</h4>
                                     <span>53 minutes ago</span>
                                   </div>
                                   <div className='activity-price'>
                                     <h6>2.31 ETH</h6>
                                     <span>125.230 U$D</span>
                                   </div>
                                  </div>
                                </MDBTabsPane>
                              </MDBTabsContent>
                </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <Footerr/>
    </div>
  );
}

export default NFTDetail;